"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
function required(source1, source2, source3) {
    return merge([source1, source2, source3], function (p, e) { return (__assign({}, p, e)); });
}
exports.required = required;
function requiredDeep(source1, source2, source3) {
    return merge([source1, source2, source3], function (p, e) { return deepmerge(p, e); });
}
exports.requiredDeep = requiredDeep;
function merge(entries, reducer) {
    if (entries[0] === undefined || entries[0] === null)
        return entries[0];
    return entries.filter(function (x) { return !!x; }).reduce(reducer, {});
}
function deepmerge(source1, source2) {
    if (typeof source1 !== 'object' || source1 === null)
        return source2 !== undefined ? source2 : source1;
    if (Array.isArray(source1)) {
        return Array.isArray(source2) ? source2 : source1.concat([source2]);
    }
    return getAllKeys(source1).concat(getAllKeys(source2)).reduce(function (p, k) {
        p[k] = deepmerge(source1[k], source2 && source2[k]);
        return p;
    }, {});
}
function getAllKeys(subject, internal) {
    if (internal === void 0) { internal = false; }
    if (typeof subject !== 'object')
        return [];
    var propertyNames = Object.getOwnPropertyNames(subject);
    var keys = internal ? propertyNames.filter(function (n) { return n !== 'constructor'; }) : propertyNames;
    var proto = Object.getPrototypeOf(subject);
    return proto !== Object.prototype ? keys.concat(getAllKeys(proto, true)) : keys;
}
//# sourceMappingURL=required.js.map